











































import Utility from '@/tools/Utility';
import { Vue, Component } from 'vue-property-decorator';
import { Sync } from 'vuex-pathify';
import moment from 'moment';

// 7 days
const WARNING_TIMEOUT_MS = 604800000;

@Component({
  name: 'AdBlockBanner',
})
export class AdBlockBanner extends Vue {
  @Sync('context/adBlock@hasAdBlock')
  protected hasAdBlock!: boolean;

  @Sync('context/adBlock@showWarning')
  protected showWarning!: boolean;

  @Sync('context/adBlock@lastWarning')
  protected lastWarning!: string | null;

  protected dismissed = false;

  protected rememberChoice = false;

  protected timeoutExpired = true;

  protected loading = true;

  /**
   * Conditions for rendering our AdBlockBanner component
   */
  protected get show() {
    return !this.dismissed
      && !this.loading
      && this.timeoutExpired
      && this.hasAdBlock
      && this.showWarning;
  }

  public created() {
    this.check();
  }

  /**
   * Dismiss button on warning banner clicked
   */
  protected dismiss() {
    this.dismissed = true;
    if (this.rememberChoice) this.showWarning = false;
    this.lastWarning = moment.utc().toISOString();
  }

  private async check() {
    this.loading = true;

    this.hasAdBlock = await Utility.hasAdBlock();

    // Check our cooldown for showing the banner if the user hasn't
    // opted out of the warning permanently
    if (this.lastWarning) {
      const lastWarningDate = moment.utc(this.lastWarning);
      const currentDate = moment.utc();
      const timeSince = currentDate.diff(lastWarningDate);
      if (timeSince > WARNING_TIMEOUT_MS) {
        this.timeoutExpired = true;
        this.lastWarning = null;
      } else {
        this.timeoutExpired = false;
      }
    }

    this.loading = false;
  }
}

export default AdBlockBanner;
